import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createSvgIcon } from "@mui/material";
const Icon = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("rect", { width: 16, height: 16, x: 4, y: 4, fill: "currentColor", rx: 2 }) });
const BaseSvgIcon = createSvgIcon(Icon(), "SwatchSquare");
function SwatchSquare({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SwatchSquare$1 = forwardRef(SwatchSquare);
export {
  SwatchSquare$1 as S
};
